import React, { useEffect, useRef, useState } from 'react';
import { Box, Icon, Image, Text } from '@quintoandar-tokko/jopijs';
import style from './customTooltip.module.scss';

function CustomTooltip({
  children,
  maxWidth = 400,
  arrowleftPosition,
  arrowTopPosition,
  isTextList = false,
  content = {},
  ...props
}) {
  const { title, text, button, buttonAction, buttonImage } = content;
  const [isVisible, setIsVisible] = useState(true);
  const [newPosition, setNewPosition] = useState(0);
  const containerRef = useRef(null);
  const emptyTooltip = text?.length === 0;
  const showArrow = arrowTopPosition || arrowleftPosition;
  const traslateTooltip = props.left || props.right;
  const [tooltipStyles, setTooltipStyles] = useState({
    maxWidth: `${maxWidth}px`,
  });
  const handleMouseEnter = () => {
    setIsVisible(true);
  };

  useEffect(() => {
    let childrenWidth;
    let childrenHeight;
    if (containerRef.current) {
      childrenWidth = containerRef.current.clientWidth;
      childrenHeight = containerRef.current.clientHeight;
    }

    if (props.top && childrenHeight)
      setTooltipStyles({
        ...tooltipStyles,
        bottom: `${childrenHeight + 10}px`,
      });
    if (props.bottom && childrenHeight)
      setTooltipStyles({ ...tooltipStyles, top: `${childrenHeight + 5}px` });
    if (props.right && childrenWidth)
      setNewPosition(-(maxWidth / 2 - childrenWidth));
    if (props.left && childrenWidth) setNewPosition(maxWidth / 2);
  }, []);

  return (
    <Box className={style.children_container} onMouseEnter={handleMouseEnter}>
      {!emptyTooltip && isVisible && (
        <Box>
          <Box
            left={traslateTooltip ? `${newPosition}px` : '50%'}
            __css={{ ...tooltipStyles, ...props.tooltip }}
            className={style.icon_tooltip}
          >
            <Box className={style.header_container}>
              {title && title.length > 0 && (
                <Text className={style.tooltipTitle}>{title}</Text>
              )}
              {title && (
                <Icon
                  onClick={() => setIsVisible(false)}
                  icon="icon-cerrar"
                  fontSize="12px"
                />
              )}
            </Box>
            {!isTextList && text}
            {isTextList && text.map((t) => <Box key={t}>{t}</Box>)}
            {button && (
              <Box
                className={style.buttonFooter_container}
                onClick={buttonAction}
              >
                <Image src={buttonImage} />
                <Text>{button}</Text>
              </Box>
            )}
          </Box>
          {showArrow && (
            <Box
              left={arrowleftPosition}
              top={arrowTopPosition}
              className={style.arrow}
            >
              -
            </Box>
          )}
        </Box>
      )}
      <Box __css={props.wrappedContainer} ref={containerRef}>
        {children}
      </Box>
    </Box>
  );
}
CustomTooltip.Icon = function ({ type }) {
  return (
    <Icon className={style.iconInfo} icon={`icon-${type}`} fontSize="16px" />
  );
};
export default CustomTooltip;
